export default __webpack_public_path__ + "static/media/dividendyeiled.a9dc999c.svg";